import React from 'react';
import { motion } from 'framer-motion';
import { personalFacts } from '../../data/om-mig-data';
export function OmMigPersonal() {
  return <section className="py-16 md:py-24 px-6 bg-card/40" data-id="element-118">
      <div className="max-w-5xl mx-auto" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12 text-center" data-id="element-120">
          <span className="text-sage font-medium tracking-widest text-xs uppercase mb-3 block" data-id="element-121">
            Lite om Peter som person
          </span>
          <h2 className="text-3xl md:text-4xl font-light text-ink mb-4" data-id="element-122">
            Utanför jobbet
          </h2>
          <p className="text-muted text-lg" data-id="element-123">
            För den som vill veta vem som faktiskt kliver in.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8" data-id="element-124">
          {personalFacts.map((fact, i) => <motion.div key={i} whileHover={{
          scale: 1.02
        }} className="bg-background rounded-2xl p-6 border border-border/50 shadow-sm" data-id="element-125">
              <div className="w-10 h-10 rounded-full bg-card flex items-center justify-center mb-4 text-ink" data-id="element-126">
                <fact.icon className="w-5 h-5" strokeWidth={1.5} data-id="element-127" />
              </div>
              <h3 className="text-base font-medium text-ink mb-2" data-id="element-128">
                {fact.title}
              </h3>
              <p className="text-sm text-muted leading-relaxed" data-id="element-129">{fact.text}</p>
            </motion.div>)}
        </div>

        {/* Celebration Cartoon */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="max-w-xs mx-auto mb-6" data-id="element-130">
          <img src="https://cdn.magicpatterns.com/uploads/5BD8gTNsE9RcP1tAZ5AeP8/image.png" alt="Firande team" className="w-full h-auto opacity-90" data-id="element-131" />
          <p className="text-xs text-muted italic text-center mt-2" data-id="element-132">
            Vi firar framgångar tillsammans
          </p>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-xs text-muted italic text-center pt-6 border-t border-border/30 max-w-md mx-auto" data-id="element-133">
          * Renoverade en fd. skola i 4 år. Blev färdig. Nästan.
        </motion.p>
      </div>
    </section>;
}